if (!customElements.get('mimicri-paginated-accordion')) {
  customElements.define(
    'mimicri-paginated-accordion',
    class MimicriPaginatedAccordion extends HTMLElement {
      connectedCallback() {
        this.pageLinks = this.querySelectorAll('[data-mimicri-page-link]');
        this.pageItems = this.querySelectorAll('[data-mimicri-page]');

        this.pageLinks.forEach((link) => {
          link.addEventListener('click', this.onPageLinkClick);
        });
      }

      disconnectedCallback() {
        this.pageLinks?.forEach((link) => {
          link.removeEventListener('click', this.onPageLinkClick);
        });
      }

      onPageLinkClick = (event) => {
        event.preventDefault();

        const page = event.currentTarget.dataset.mimicriPageLink;
        this.activatePage(page);
      };

      activatePage(page) {
        this.dataset.page = page;

        this.pageLinks.forEach((link) => {
          const isActive = link.dataset.mimicriPageLink === page;

          if (isActive) {
            link.setAttribute('aria-current', 'page');
          } else {
            link.removeAttribute('aria-current');
          }
        });

        let firstVisibleItem = null;

        this.pageItems.forEach((item) => {
          const isVisible = item.dataset.mimicriPage === page;

          item.hidden = !isVisible;
          item.open = false;

          if (isVisible && firstVisibleItem === null) {
            firstVisibleItem = item;
          }
        });

        if (firstVisibleItem) {
          firstVisibleItem.open = true;
        }
      }
    }
  );
}
